// @ts-nocheck - FormStatic/formatter
import React from 'react';
import KwPanel from '../../common/KwPanel';
import FormStatic from '../../common/FormStatic';
import { CommaNumber_NoDecimal } from '../../../util/formatter';
import FormattedDate from '../../common/FormattedDate';
import TransactionStatusBadge from './TransactionStatusBadge';
import KeyProviderLink from '../../common/links/KeyProviderLink';
import UserLink from '../../common/links/UserLink';
import { useTranslation } from 'react-i18next';

export interface ReportedSoldTransactionDetailsProps {
  transaction: any;
}

const ReportedSoldTransactionDetails = ({
  transaction,
}: ReportedSoldTransactionDetailsProps) => {
  const { t } = useTranslation();
  return (
    <KwPanel className="mb-4">
      <header className="mb-2">
        <h2 className="no-margin ">{t('Sold transaction details')}</h2>
      </header>
      <div className="row">
        <div className="col">
          <FormStatic label={t('Key provider')}>
            <KeyProviderLink
              id={transaction.keyProviderId}
              name={transaction.keyProviderName}
            />
          </FormStatic>
          <FormStatic label={t('Total keys')} className="num no-wrap">
            {transaction.batchCount >= 0
              ? CommaNumber_NoDecimal(transaction.batchCount)
              : ''}
          </FormStatic>
          <FormStatic label={t('Uploaded by')}>
            <>
              <UserLink
                id={transaction.manualImportUserId}
                name={transaction.manualImportUser}
              />
              , {transaction.manualImportUserCompany}
            </>
          </FormStatic>
        </div>
        <div className="col">
          <FormStatic label={t('Date uploaded')}>
            <FormattedDate value={transaction.creationDate} variant="noHtml" />
          </FormStatic>
          <FormStatic label={t('Status')}>
            <TransactionStatusBadge
              success={transaction.success}
              partialSuccess={transaction.partialSuccess}
              message={transaction.message}
              status={transaction.status}
            />
          </FormStatic>
          <FormStatic label={t('Description')}>
            {transaction.description}
          </FormStatic>
          <FormStatic label={t('Message')}>{transaction.message}</FormStatic>
        </div>
      </div>
    </KwPanel>
  );
};

export default ReportedSoldTransactionDetails;
